import environment from "@menu-environment";

export const defaultLanguage = environment.menu.defaultLanguage;

export const rootElementId = "root";

export const windowProps: any = window;

export const maxMobileWidth = 992;

export const SiteConstants = {
    businessPathPrefix: "/business/"
}

export const PermutiveScript = Object.freeze({
    tag: "https://b2d7ba82-21e5-456c-bc98-05c7e0cd93de.edge.permutive.app/b2d7ba82-21e5-456c-bc98-05c7e0cd93de-web.js"
});

export const keys = {
    ciamAccess: "access", //to rename?
    connectAccess: "connect-store",
    loggedInBusinessUser: "user.commercial",
    inboxData: "inbox",
    selfServiceSession: "dstv-ss.session",
    selfServiceUser: "dstv-ss.user"
}

export const eventNames = {
    config: "onMenu",
    inbox: "inbox",
    ciamLogin: "onCiamLogin", //to rename  / remove?
    update: "menu.update"
}
